import { render, staticRenderFns } from "./ListBusinessServices.vue?vue&type=template&id=1584cecd&scoped=true&lang=pug&"
import script from "./ListBusinessServices.vue?vue&type=script&lang=js&"
export * from "./ListBusinessServices.vue?vue&type=script&lang=js&"
import style0 from "./ListBusinessServices.vue?vue&type=style&index=0&id=1584cecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584cecd",
  null
  
)

export default component.exports